module.exports = function getResource(label, vars = []) {
    const resources = {
        accept: 'I accept the',
        termsConditions: 'Terms & Conditions',
        mustAcceptTermsConditions: 'You must accept terms and conditions first.',
        buttonCTAEnrolled: 'Already Enrolled',
        buttonCTAEnrollNow: 'Enroll Now',
        flashTermsModalTitle: 'Flash Terms & Conditions'
    };
    return resources[label];
};
